// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBhAXGAq_eelSR89dGG1i8s9tsxyD8-46I",
  authDomain: "fxwars.firebaseapp.com",
  projectId: "fxwars",
  storageBucket: "fxwars.firebasestorage.app",
  messagingSenderId: "169969978508",
  appId: "1:169969978508:web:1a2f8501e5857ab523ffa9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Functions and get a reference to the service
export const functions = getFunctions(app);

export default app; 